export const setAppTitle = (title: string): void => {
  document.title = title;
  document
    .getElementById('document-description')
    ?.setAttribute('content', title);
};

export const setAppFavicon = (icon: string): void => {
  document.getElementById('favicon')?.setAttribute('href', icon);
  document.getElementById('apple-touch-icon')?.setAttribute('href', icon);
};

export const setAppTheme = (color: string): void => {
  document.getElementById('apple-theme-color')?.setAttribute('content', color);
};
